import { Button, Col, Form, Modal, Row } from 'react-bootstrap'
import './Deck.scss'
import React, { useEffect, useState } from 'react';
import { SECTIONS } from '../PlayerSection/PlayerSection';
import { IMG, hideCard, shuffleArray, ungroupCard } from '../../Commons/Functions';
import { useGameContext } from '../../Commons/GameContext';
import { ACTION_MODES } from '../ActionMode';
import TopCardImage from './TopCardImage';
import TopCardDropdown from './TopCardDropdown';
import DeckInteractionZone from './DeckInteractionZone';
import MouseDropableSection from '../MouseDropableSection';
import Sleeve from '../../Home/Preferences/Sleeves/Sleeve';
import { SLEEVE_DATA_TEST } from '../Card/Card';

const Deck = React.memo(function Deck(props) {
    let deckCount = props.deck.length
    const isOpponentDeck = props.opponentIds === undefined
    const [showDeckSearch, setShowDeckSearch] = useState(false);
    const [showTopDeckManager, setShowTopDeckManager] = useState(false);
    const [showDrawXModal, setShowDrawXModal] = useState(false);

    const [topCardsRevealedCount, setTopCardsRevealedCount] = useState(0)
    const [topCardsRevealedTotal, setTopCardsRevealedTotal] = useState(0)

    const [hasMovedCard, setHasMovedCard] = useState(false)
    const { gameData } = useGameContext()

    const [actionModeText, setActionModeText] = useState("Draw")

    function moveCard(i, direction) {
        let index = props.deck.length - i - 1
        if (index + direction < 0 || index + direction > props.deck.length - 1) { return }

        let tmpDeck = [...props.deck]

        const tmpCard = tmpDeck[index]
        tmpDeck[index] = tmpDeck[index + direction]
        tmpDeck[index + direction] = tmpCard

        props.setDeck(tmpDeck)
        setHasMovedCard(true)
    }

    function toSection(i, section) {
        let index = props.deck.length - i - 1
        if (index < 0 || index > props.deck.length - 1) { return }

        let newDeck = [...props.deck]  // A virer quand le draw initial sera avec un bouton
        let newCard = newDeck.splice(index, 1)[0]
        props.setDeck(newDeck)

        let rect = props.deckRef.current.getBoundingClientRect()
        let sectionData = props.sections.sectionsDict[SECTIONS.DECK]

        newCard.position = {
            section: SECTIONS.DECK,
            pos: { left: rect.left, top: rect.top },
            cardSize: {
                width: sectionData.cardWidth,
                height: sectionData.cardHeight
            }
        }
        hideCard(newCard, "yes", props.playerId, props.opponentIds)

        props.visibleCardsRef.current.push(newCard)
        if ('requestIdleCallback' in window) {
            requestIdleCallback(() => {
                props.moveCard(newCard, section)
                props.repositionCards()
            });
        } else {
            setTimeout(() => {
                props.moveCard(newCard, section)
                props.repositionCards()
            }, 0);
        }
    }

    function shuffleDeck() {
        if (props.deck && props.setDeck) {
            let tmp = [...props.deck]
            shuffleArray(tmp)
            props.setDeck(tmp)
            props.sendToHistory("shuffled their deck")
        }
    }

    function onDeckSearchExit() {
        if (props.deck && props.setDeck) {
            let tmp = [...props.deck]
            shuffleArray(tmp)
            props.setDeck(tmp)
        }
    }

    function toDeckBottom(i, count = 1) {
        if (props.deck && props.setDeck) {
            let index = props.deck.length - i - 1
            console.log(i, count, index)
            if (index < 0 || index > props.deck.length - 1) { return }
            let newDeck = [...props.deck]
            let newCards = newDeck.splice(index, count)
            newCards.forEach((c) => {
                newDeck.unshift(c)
            })
            props.setDeck(newDeck)
            if (count === 1) {
                props.sendToHistory("put a card from the top of their deck to the bottom")
            } else {
                props.sendToHistory("put " + count + " cards to the bottom randomly")
            }
        }
    }

    function draggedCardToDeckTop(card) {
        const wasDraggedFromDeck = card.position.section === SECTIONS.DECK;
        if (wasDraggedFromDeck) {

        } else {
            if (props.deck && props.setDeck && !card.isToken) {
                ungroupCard(card, props.visibleCardsRef.current)
                card.counters = [{}, {}]
                card.isTapped = false
                if (props.currentActionMode.keys.shift) {
                    props.setDeck([card, ...props.deck])
                } else {
                    props.setDeck([...props.deck, card])
                }
                props.sendToHistory("put at the top of their deck", card)
            }

            const cardIndex = props.visibleCardsRef.current.findIndex((a) => a.id === card.id)
            if (cardIndex !== -1) {
                props.visibleCardsRef.current.splice(cardIndex, 1)
            }
        }
    }

    function revealCard(card) {
        // Ajouter un truc visuel cote joueur ?
        props.sendToHistory("revealed from deck", card)
    }

    function deckClick() {
        if (props.currentActionMode.action == ACTION_MODES.DISCARD) {
            if (props.currentActionMode.keys.shift) {
                toSection(props.deck.length - 1, SECTIONS.DISCARD)
            } else {
                toSection(0, SECTIONS.DISCARD)
            }
        } else if (props.currentActionMode.action == ACTION_MODES.REMOVE) {
            if (props.currentActionMode.keys.shift) {
                toSection(props.deck.length - 1, SECTIONS.EXILE)
            } else {
                toSection(0, SECTIONS.EXILE)
            }
        } else {
            if (props.currentActionMode.keys.shift) {
                props.draw(1, false, true) // MAYBE DRAW FROM BOTTOM ?
            } else {
                props.draw(1)
            }
        }
    }

    useEffect(() => {
        if (props.currentActionMode) {
            if (props.currentActionMode.action == ACTION_MODES.DISCARD) {
                setActionModeText("Mill")
            } else if (props.currentActionMode.action == ACTION_MODES.REMOVE) {
                setActionModeText("Remove")
            } else {
                setActionModeText("Draw")
            }
        } else {
            setActionModeText("Draw")
        }
    }, [props.currentActionMode])

    useEffect(() => {
        setTopCardsRevealedCount(0)
        setTopCardsRevealedTotal(0)
        setHasMovedCard(false)
    }, [showTopDeckManager])

    function deckSearchOnHide() {
        setShowDeckSearch(false)
        props.setIsTextInputFocused(false)
        props.sendToHistory("looked at and shuffle their deck")
    }

    return (
        <MouseDropableSection
            className={'position-absolute deck' + (deckCount == 0 ? " empty" : "")}
            sectionRef={props.deckRef}
            section={SECTIONS.DECK}
            cardDraggedRef={props.cardDraggedRef}
            moveCard={draggedCardToDeckTop}
            repositionCards={props.repositionCards}
        >

            <div className='deck-pile position-absolute top-0 start-0 w-100 h-100'>
                {[...Array(deckCount)].map((c, i) => {
                    return (<img key={i} style={{ transform: "translateZ(" + (i - deckCount) * 2 + "px) translateY(" + (i - deckCount) * 0.25 + "px)" }} className='position-absolute top-0 start-0 w-100 h-100' src={require('../../Commons/Assets/Images/card-placeholder.jpg')} />)
                })}
            </div>
            <TopCardImage deck={props.deck} playerId={props.playerId} topCardHiddenTo={props.topCardHiddenTo} gameData={gameData} />
            <p className='position-absolute top-50 start-50 translate-middle section-card-count'>{deckCount}</p>
            <DeckInteractionZone
                deck={props.deck}
                isOpponentDeck={isOpponentDeck}
                currentActionMode={props.currentActionMode}
                playerId={props.playerId}
                topCardHiddenTo={props.topCardHiddenTo}
                setFocusedCard={props.setFocusedCard}
                draw={props.draw}
                createDraggedCard={props.createDraggedCard}
                setDeck={props.setDeck}
                deckClick={deckClick}
                menu={
                    <TopCardDropdown
                        playerId={props.playerId}
                        opponentIds={props.opponentIds}
                        opponentsData={props.opponentsData}
                        deck={props.deck}
                        topCardHiddenTo={props.topCardHiddenTo}
                        setShowTopDeckManager={setShowTopDeckManager}
                        setShowDeckSearch={setShowDeckSearch}
                        setShowDrawXModal={setShowDrawXModal}
                        setIsTextInputFocused={props.setIsTextInputFocused}
                        sendToHistory={props.sendToHistory}
                        setTopCardHiddenTo={props.setTopCardHiddenTo}
                        toSection={toSection}
                        shuffleDeck={shuffleDeck}
                        giveCardAtIndexTo={props.giveCardAtIndexTo}
                    />
                }
                leftClickText={actionModeText}
                cardDraggedRef={props.cardDraggedRef}
                draggedReplacementText={props.currentActionMode.keys.shift ? "Bottom deck" : "Top deck"}
            />

            <TopDeckManager
                deck={props.deck}
                show={showTopDeckManager}
                onHide={() => {
                    setShowTopDeckManager(false)
                }}
                onExit={() => {
                    let historyText = "has looked the top " + topCardsRevealedTotal + " card" + (topCardsRevealedCount > 1 ? "s" : "")
                    if (hasMovedCard) {
                        historyText += " and reorganized them"
                    }
                    props.sendToHistory(historyText)
                    setTopCardsRevealedCount(0)
                }}
                moveCard={moveCard}
                toSection={toSection}
                cardsRevealedCount={topCardsRevealedCount}
                cardsRevealedTotal={topCardsRevealedTotal}
                setCardsRevealedCount={setTopCardsRevealedCount}
                increaseCardsRevealedTotal={() => setTopCardsRevealedTotal(topCardsRevealedTotal + 1)}
                toDeckBottom={toDeckBottom}
                revealCard={revealCard}
            />
            <DeckSearch
                deck={props.deck}
                show={showDeckSearch}
                onHide={deckSearchOnHide}
                toSection={toSection}
                onDeckSearchExit={onDeckSearchExit}
            />
            <DrawXModal
                deck={props.deck}
                show={showDrawXModal}
                handleClose={() => setShowDrawXModal(false)}
                draw={props.draw}
            />
        </MouseDropableSection>
    )
});
export default Deck;

function TopDeckManager(props) {
    return (
        <Modal className="fullscreen-modal modal-game-panel" onExit={props.onExit} backdrop="static" show={props.show} onHide={props.onHide} centered>
            <Modal.Header className='d-flex justify-content-between'>
                <Modal.Title>Look and manage the top of your deck</Modal.Title>
                <Button variant="primary" onClick={props.onHide}>
                    Close
                </Button>
            </Modal.Header>
            <Modal.Footer className='d-flex'>
                <p>Card currently revealed: {props.cardsRevealedCount}/{props.cardsRevealedTotal}</p>
                <Button variant="primary" className="me-auto" onClick={() => { props.setCardsRevealedCount(props.cardsRevealedCount + 1); props.increaseCardsRevealedTotal() }}>Show one more</Button>
                <div className='d-flex ms-auto'>
                    {props.cardsRevealedCount > 0 && (<Button variant="secondary" onClick={() => {
                        props.toDeckBottom(props.cardsRevealedCount - 1, props.cardsRevealedCount)
                        props.setCardsRevealedCount(0)
                    }}>All randomly at bottom</Button>)}
                </div>
            </Modal.Footer>
            <Modal.Body>
                {props.cardsRevealedCount > 0 && (
                    <Row>
                        {props.cardsRevealedCount && props.deck.slice(-1 * props.cardsRevealedCount).reverse().map((c, i) => {
                            return (<Col xs={3} key={c.id}>
                                <DeckCard
                                    card={c}
                                    index={i}
                                    cardsRevealedCount={props.cardsRevealedCount}
                                    moveCard={props.moveCard}
                                    toSection={(i, s) => { props.toSection(i, s); props.setCardsRevealedCount(props.cardsRevealedCount - 1) }}
                                    toDeckBottom={() => { props.toDeckBottom(i); props.setCardsRevealedCount(props.cardsRevealedCount - 1) }}
                                    revealCard={() => { props.revealCard(c) }}
                                /></Col>)
                        })}
                    </Row>)}
                {props.cardsRevealedCount == 0 && (
                    <p className='box-container justify-content-center mx-5'>You are not looking at any card yet</p>
                )}
            </Modal.Body>
        </Modal>
    )
}

function DeckSearch(props) {
    const [searchQuery, setSearchQuery] = useState("")

    return (
        <Modal className="fullscreen-modal modal-game-panel" backdrop="static" show={props.show} onHide={props.onHide} centered
            onExited={() => {
                setSearchQuery("")
                props.onDeckSearchExit()
            }}>
            <Modal.Header className='d-flex justify-content-between'>
                <Modal.Title>Search for cards in your deck</Modal.Title>
                <Button variant="primary" onClick={props.onHide}>
                    Close and shuffle
                </Button>
            </Modal.Header>
            <Modal.Footer>
                <p>Search:</p>
                <Form.Control
                    type="text"
                    defaultValue={searchQuery}
                    placeholder="Card name"
                    className='w-25 me-auto'
                    onChange={(e) => {
                        setSearchQuery(e.target.value.toLowerCase())
                    }}
                />
            </Modal.Footer>
            <Modal.Body>
                <Row>
                    {props.deck.map((c, i) => {
                        if (c.cardData.name.toLowerCase().includes(searchQuery)) {
                            return (<Col xs={3} key={c.id}>
                                <DeckCard
                                    card={c}
                                    index={props.deck.length - 1 - i}
                                    toSection={props.toSection}
                                />
                            </Col>)
                        }
                    })}
                </Row>
            </Modal.Body>
        </Modal>
    )
}

function DeckCard(props) {
    return (
        <div className="modal-panel-card w-100 h-100 position-relative d-flex flex-column justify-content-between">
            <div className='wrapper'>
                <IMG src={props.card.cardData.face.front.image} className='h-100 w-100' />
                <div className="box-container flex-column m-0 position-absolute start-50 top-50 translate-middle d-flex" style={{ zIndex: 1000 }}>
                    <h5>{props.card.cardData.name}</h5>
                    <Button className="m-1" onClick={() => props.toSection(props.index, SECTIONS.STACK)}>Play</Button>
                    <Button className="m-1" onClick={() => props.toSection(props.index, SECTIONS.HAND)}>To hand</Button>
                    <Button className="m-1" onClick={() => props.toSection(props.index, SECTIONS.DISCARD)}>Discard</Button>
                    <Button className="m-1" onClick={() => props.toSection(props.index, SECTIONS.EXILE)}>Remove</Button>
                    <Button className="m-1" onClick={() => props.toSection(props.index, SECTIONS.EXILE_HIDDEN)}>Remove hidden</Button>
                    {props.revealCard && props.toDeckBottom && (<>
                        <Button className="m-1" onClick={() => props.revealCard()}>Reveal</Button>
                        <Button className="m-1" onClick={() => props.toDeckBottom()}>To deck bottom</Button>
                    </>)}
                </div>
            </div>
            {props.moveCard && (<div className="position-absolute bottom-0 start-50 w-50 pe-none box-container d-flex justify-content-between translate-middle-x m-0 mb-1">
                {props.index != 0 ? (<Button onClick={() => props.moveCard(props.index, 1)} className="pe-auto" style={{ left: "-1rem" }}>{"<"}</Button>) : (<div></div>)}
                <h5>{props.index + 1}</h5>
                {props.index != props.cardsRevealedCount - 1 ? (<Button onClick={() => props.moveCard(props.index, -1)} className="pe-auto" style={{ right: "-1rem" }}>{">"}</Button>) : (<div></div>)}
            </div>)}
        </div>
    )
}

function DrawXModal(props) {
    const [x, setX] = useState(1)
    return (
        <Modal className="" onEnter={() => setX(1)} show={props.show} onHide={props.handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Draw X</Modal.Title>
            </Modal.Header>
            <Modal.Body >
                <Form.Control
                    className="text-start position-relative"
                    type="number"
                    placeholder="1"
                    id="draw-x-input"
                    autoFocus
                    value={x}
                    onChange={(e) => {
                        setX(Math.max(1, Math.min(props.deck.length, e.currentTarget.value)))
                    }}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => {
                    props.handleClose()
                }}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={() => {
                    props.handleClose()
                    props.draw(x)
                }}>
                    {`Draw ${x}`}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}